import type { SVGProps } from 'react';
const SvgPinDrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#pin_drop_svg__a)">
      <path
        fill="currentColor"
        d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11Zm-8 0c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 1 1-4 0ZM5 20v2h14v-2H5Z"
      />
    </g>
    <defs>
      <clipPath id="pin_drop_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPinDrop;
